module.exports = __webpack_public_path__ + "media/images/icons/flags/BJ-a610907d320bbbbd475c1bac86dc14f8.svg";